import { render, staticRenderFns } from "./probationPlanApproval.vue?vue&type=template&id=38b83084&scoped=true&"
import script from "./probationPlanApproval.vue?vue&type=script&lang=js&"
export * from "./probationPlanApproval.vue?vue&type=script&lang=js&"
import style0 from "./probationPlanApproval.vue?vue&type=style&index=0&id=38b83084&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b83084",
  null
  
)

export default component.exports